module.exports = __webpack_public_path__ + "static/sport/register-2.e477997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/form/register-2.png
// module id = QX4n
// module chunks = 0